export const notificationsDisabledHeaderButton = "jhgKHe";
export const notificationsHeaderButton = "fJ8Y3";
export const notificationsHeaderButtonWithCount = "syZrge";
export const settingsHeaderButton = "QucxFc";
export const myDayHeaderButton = "r9nXUd";
export const premiumHeaderButton = "EeNaHe";
export const rewardsHeaderButton = "Zy7GYc";
export const teamsChatHeaderButton = "r6XSyb";
export const syncHeaderButton = "ilCtud";
export const syncHeaderButtonTooltip = "ph6VOd";
export const teamsChatHeaderButtonWithCount = "eu3b4b";
export default {notificationsDisabledHeaderButton,notificationsHeaderButton,notificationsHeaderButtonWithCount,settingsHeaderButton,myDayHeaderButton,premiumHeaderButton,rewardsHeaderButton,teamsChatHeaderButton,syncHeaderButton,syncHeaderButtonTooltip,teamsChatHeaderButtonWithCount};